// awsLocation.js
import {
  SearchPlaceIndexForSuggestionsCommand,
  SearchPlaceIndexForTextCommand
} from "@aws-sdk/client-location";
import { GeoPlacesClient, AutocompleteCommand } from "@aws-sdk/client-geo-places";
import { locationClient, geoPlacesClient } from "./awsConfig";
import { GetPlaceCommand } from "@aws-sdk/client-location";
const INDEX_NAME = "scg-gyyst-dev-wus2-place-index-multimodal"; // Your Place Index name (HERE provider) //New-place-index
const socalCenter = [-117, 34];
const VALID_PLACE_TYPE = ["PointAddress", "InterpolatedAddress"];
const MAX_RESULTS = 5;
const defaultBounds = {
  north: socalCenter.lat + 3.22, // 37.22
  south: socalCenter.lat - 3.22, // 30.78
  east: socalCenter.lng + 3.22,  // -113.78
  west: socalCenter.lng - 3.22,  // -120.22
};

// AWS expects [west, south, east, north]
const LOS_ANGELES_COORDINATES = [
  defaultBounds.west,
  defaultBounds.south,
  defaultBounds.east,
  defaultBounds.north,
];


export async function getAddressSuggestions(query, signal) {


const command = new AutocompleteCommand({
  IndexName: INDEX_NAME,
  QueryText: query,
  BiasPosition: socalCenter,
  Filter: {
    IncludeCountries: ["USA"]
  },
  AdditionalFeatures: ["Core"],
  MaxResults: 20 // or your preferred number
});

  try {
    const response = await geoPlacesClient.send(command, { abortSignal: signal });
    const filteredResponse = response.ResultItems.filter(data => VALID_PLACE_TYPE.includes(data?.PlaceType ?? '')).slice(0, MAX_RESULTS)
    return { results: filteredResponse || [], error: false };
  } catch (err){
    if (err.name === "AbortError") {
      console.log("Request aborted:", query);
      return { results: [], error: false };
    } else {
      console.error("Error fetching suggestions:", err);
      return { results: [], error: true };
    }
  }
}

export async function getFullAddress(selectedText) {
  const command = new SearchPlaceIndexForTextCommand({
    IndexName: INDEX_NAME,
    Text: selectedText,
    MaxResults: 1,
  });

  try {
    const response = await locationClient.send(command);
    return response.Results[0]?.Place || null;
  } catch (err) {
    console.error("Error fetching full address:", err);
    return null;
  }
}

export async function getStreetOnly(placeId) {
  try {
    const command = new GetPlaceCommand({
      IndexName: INDEX_NAME,  // same place index used for suggestions
      PlaceId: placeId,
    });
    const response = await locationClient.send(command);

    const place = response.Place;
    const street = [
      place.Address?.StreetNumber,
      place.Address?.Street
    ].filter(Boolean).join(" ");

    return street || place.Label; // fallback if street not available
  } catch (err) {
    console.error("GetPlace error:", err);
    return "";
  }
}

export async function getPlaceInfo(placeId) {
  try {
    const command = new GetPlaceCommand({
      IndexName: INDEX_NAME,  // same place index used for suggestions
      PlaceId: placeId,
    });
    const response = await locationClient.send(command);

    const place = response.Place;

    return place; // fallback if street not available
  } catch (err) {
    console.error("GetPlaceInfo error:", err);
    return "";
  }
}


